"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useEventListener_1 = __importDefault(require("../useEventListener"));
const hooks_1 = require("../../hooks");
function useSetFocus({ ref, focusCallback, blurCallback }) {
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const isFocusedPrev = (0, hooks_1.usePrevious)(isFocused);
    (0, react_1.useEffect)(() => {
        if (isFocusedPrev === undefined) {
            // Don't call callback on first render
            return;
        }
        // Calling back from here to be sure that isFocused value have already been updated
        if (isFocused) {
            focusCallback && focusCallback();
        }
        else {
            blurCallback && blurCallback();
        }
    }, [blurCallback, focusCallback, isFocused, isFocusedPrev]);
    const focus = (0, react_1.useCallback)(() => {
        ref.current.focus();
    }, [ref]);
    const blur = (0, react_1.useCallback)(() => {
        ref.current.blur();
    }, [ref]);
    const onFocus = () => {
        setIsFocused(true);
    };
    const onBlur = () => {
        setIsFocused(false);
    };
    (0, useEventListener_1.default)({
        eventName: "focus",
        ref,
        callback: onFocus
    });
    (0, useEventListener_1.default)({
        eventName: "blur",
        ref,
        callback: onBlur
    });
    return { isFocused, focus, blur };
}
exports.default = useSetFocus;
